import React, { useContext } from "react"
import { SurveyContext } from "../Main/SurveyContext"
import Button from "../Button"
import Icon from "../Icon"

type Props = {
  onPreviousStepClick: () => void
  surveyNumber: number
  stepNumber: number
  totalSteps: number
}

const SurveyProgress: React.FC<Props> = ({
  onPreviousStepClick,
  surveyNumber,
  stepNumber,
  totalSteps
}) => {
  const surveyContext = useContext(SurveyContext)

  if (!surveyContext) {
    return null
  }

  return (
    <div className="flex justify-between text-neutral-700 font-semibold items-center">
      <Button
        type="button"
        variant="tertiary"
        onClick={onPreviousStepClick}
        id="previousStepButton"
      >
        <Icon
          name="arrowLeft"
          className="w-5 h-5 text-neutral-400"
          testId="arrowLeft"
        />
      </Button>
      <span>Spørgeskema {surveyNumber}</span>
      <span>
        {stepNumber}/{totalSteps}
      </span>
    </div>
  )
}

export default SurveyProgress
